import { graphql, PageProps } from 'gatsby';
import React from 'react';
import { SEO } from '../../components/Seo';
import { PropertyPagePageQueryQuery } from '../../types/graphqlTypes';
import PropertyDetails from '../../components/properties/PropertyDetails';
import { getPropertySchema } from '../../utils/getPropertySchema';
import { urlBuilder } from '../../components/Img';
import { IGatsbyImageData } from 'gatsby-plugin-image';

export default PropertyDetails;

export const Head = ({ data }: PageProps<PropertyPagePageQueryQuery>) => {
  const { property } = data;
  const { firstImage } = property;
  const isCommercial = property.commercial;
  // Schema
  const schema = !isCommercial ? getPropertySchema(property) : null;


  const imageOptions = {
    layout: 'constrained',
    cropFocus: 'center',
    quality: 80,
  };

  // Produce image for social
// this is tied to AWS setup.
  const soicalImage = firstImage?.largestImagePath ?   urlBuilder({baseUrl: firstImage.largestImagePath, width: 1200, height: 630 , format: 'jpeg', options: imageOptions}) : undefined

  return (
    <SEO
      data={property.seo}
      schema={schema || []}
      canonical={property.relativeUrl}
      image={soicalImage}
    />
  );
};

export const pageQuery = graphql`
  query PropertyPagePageQuery($id: String!) {
    property: kfhPropertyTypeInterface(id: { eq: $id }) {
      ...PropertyDetails
    }
  }
`;
